import { useState } from 'react'
import React from 'react'
import axios from 'axios'
import './btc.css' // 引用全局样式文件
import moment from 'moment'

export default function Btc() {
  const [data, setData] = useState({})
  const fetchData = async () => {
    try {
      const result = await axios(`btc`);
      setData(result.data)
    } catch (error) {
      console.log(error)
    }
  };
  React.useEffect(() => {
    fetchData();
    // 以下setInterval只能放在useEffect之内，否则死循环
    setInterval(() => {
      fetchData();
    }, 1000 * 3);
  }, []);
  return (
    <div className="container">
      <div className="price">{data.price ? Number.parseFloat(data.price).toFixed(1) : ''}</div>
      <div className="date">{moment(data.date).format('HH:mm:ss')}</div>
    </div>
  )
}
